import { Icon, Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './MealPlanWidget.styled';

type MealPlanWidgetProps = {
    copy: {
        sectionHeader: string;
        title: string;
        tag: string;
        subTitle: string;
    };
    image: string;
    onClick: () => void;
};

export const MealPlanWidget = ({ copy, image, onClick }: MealPlanWidgetProps) => {
    return (
        <>
            <Text mb={8} type="large-text">
                {copy.sectionHeader}
            </Text>
            <S.Container $image={image} onClick={onClick}>
                <S.Tag>
                    <Text type="caption">{copy.tag}</Text>
                </S.Tag>
                <S.Title>
                    <Text type="large-text">{copy.title}</Text>
                    <Icon name="arrowRight" color="text-light" />
                </S.Title>
                <Text type="small-text" color="text-light">
                    {copy.subTitle}
                </Text>
            </S.Container>
        </>
    );
};
